import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { CoreModule } from '@core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { provideNgxMask } from 'ngx-mask';

import { GlobalConfig, ToastrModule } from 'ngx-toastr';
import { NbDatepickerModule, NbMenuModule, NbThemeModule } from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BootstrapModule } from './bootstrap/bootstrap.module';
import { CommonModule, registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import { NotFoundComponent } from './public/not-found-component/not-found.component';
import { RedirectComponent } from './public/redirect/redirect.component';
import { environment } from '@env/*';
import { IModuleTranslationOptions, ModuleTranslateLoader } from '@larscom/ngx-translate-module-loader';
import { LOCALE_DEFAULT, LOCALE_MODULES } from './locales.enum';
import { TranslateLoader, TranslateModule, TranslateParser, TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { PrimeNGConfig } from 'primeng/api';
import { TranslateICUParser } from '@core/util/translate-icu-parser';

registerLocaleData(localeRu, 'ru');

export const notifierConfig: Partial<GlobalConfig> = {
  positionClass: 'toast-top-right',
};

export const moduleHttpLoaderFactory = (http: HttpClient) => {
  const options: IModuleTranslationOptions = {
    modules: LOCALE_MODULES,
  };

  return new ModuleTranslateLoader(http, options);
};

@NgModule({
  declarations: [AppComponent, NotFoundComponent, RedirectComponent],
  imports: [
    CommonModule,
    BrowserModule,
    CoreModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ToastrModule.forRoot(notifierConfig),
    NbThemeModule.forRoot({ name: 'umag' }),
    NbMenuModule.forRoot(),
    NbEvaIconsModule,
    NbDatepickerModule.forRoot(),
    BootstrapModule,
    TranslateModule.forRoot({
      defaultLanguage: LOCALE_DEFAULT,
      loader: {
        provide: TranslateLoader,
        useFactory: moduleHttpLoaderFactory,
        deps: [HttpClient],
      },
      useDefaultLang: environment.production && !environment.staging,
      parser: {
        provide: TranslateParser,
        useClass: TranslateICUParser,
      },
    }),
  ],
  bootstrap: [AppComponent],
  providers: [{ provide: LOCALE_ID, useValue: 'ru' }, provideNgxMask()],
})
export class AppModule {
  constructor(private t: TranslateService, private primeNgConfig: PrimeNGConfig) {
    this.t.use(LOCALE_DEFAULT);
    localStorage.setItem('lang', LOCALE_DEFAULT);
    this.t
      .get('primeng')
      .pipe(take(1))
      .subscribe((res) => this.primeNgConfig.setTranslation(res));
  }
}
